
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gKxUw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $91uAX = parcelRequire("91uAX");


var $isp1U = parcelRequire("isp1U");


var $eoEVy = parcelRequire("eoEVy");


var $2dlSO = parcelRequire("2dlSO");


var $bSAnS = parcelRequire("bSAnS");


var $kEjXh = parcelRequire("kEjXh");

const $9d2832a2132f7625$var$ANALYTICS_CHANNEL = 'aiMate';
const $9d2832a2132f7625$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $9d2832a2132f7625$var$constructFeedbackContext = (additionalFields, aaid, tenantId)=>{
    const userAgent = navigator.userAgent;
    const screenResolution = `${window.screen.width} x ${window.screen.height}`;
    const feedbackContext = {
        'User-Agent': userAgent,
        'Screen Resolution': screenResolution,
        'User Account Id': aaid ?? 'unknown',
        'Tenant Id': tenantId ?? 'unknown',
        /* Other context fields will have to be passed in as props, since there aren't public hooks to get these.
    Environment: metadata.environment ?? '',
    Product: metadata.product ?? '',
    Edition: metadata.edition ?? '',
    */ ...additionalFields
    };
    const feedbackContextStr = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${value}`).join('\n');
    return [
        {
            id: $9d2832a2132f7625$var$FEEDBACK_CONTEXT_FIELD_ID,
            value: feedbackContextStr
        }
    ];
};
const $9d2832a2132f7625$var$getFeedbackConfig = (variant)=>{
    switch(variant){
        case (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitle,
                rateExperience: (0, $bSAnS.messages).rateExperience,
                entrypointId: '63867aef-06e5-4520-855f-4d29e062f22c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).ROVO:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleNoCreate,
                rateExperience: (0, $bSAnS.messages).rateExperienceNoCreate,
                entrypointId: '63867aef-06e5-4520-855f-4d29e062f22c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO_FROM_JIRA:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitle,
                rateExperience: (0, $bSAnS.messages).rateExperience,
                // https://customerfeedback.atlassian.net/jira/servicedesk/projects/JIRAAIFC
                entrypointId: 'e79ff340-38e9-4c53-9d3b-87a776964f2c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).REMIX:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleRemix,
                rateExperience: (0, $bSAnS.messages).rateExperienceRemix,
                entrypointId: '0953facd-d9b5-4ce6-b1d6-7bae93e09b2f'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).SLIDES:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleSlides,
                rateExperience: (0, $bSAnS.messages).rateExperienceSlides,
                entrypointId: 'dd0e4a6a-6a39-40d4-961f-a5bf382c9fb0'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO_FROM_JSM:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitle,
                rateExperience: (0, $bSAnS.messages).rateExperience,
                entrypointId: 'ad7943a4-aa8a-4f69-b317-7241ec65472c'
            };
        case (0, $kEjXh.SmartCreateFeedbackVariant).ROVO_INSIGHTS_FROM_JSM:
            return {
                feedbackTitle: (0, $bSAnS.messages).feedbackTitleRovoInsights,
                rateExperience: (0, $bSAnS.messages).rateExperienceRovoInsights,
                // https://customerfeedback.atlassian.net/jira/servicedesk/projects/JSAIF
                entrypointId: '122afbe6-2758-40f4-a24e-59c01eb0fd39'
            };
    }
};
const $9d2832a2132f7625$export$35c06614b8d216da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartCreateFeedback(props) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, aaid: aaid, email: email } = (0, $isp1U.useProfileController)();
    let t0;
    if ($[0] !== aaid || $[1] !== email || $[2] !== name || $[3] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($9d2832a2132f7625$export$4a210f0e33a62fe0, {
            name: name,
            aaid: aaid,
            email: email,
            ...props
        });
        $[0] = aaid;
        $[1] = email;
        $[2] = name;
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : function SmartCreateFeedback(props) {
    const { name: name, aaid: aaid, email: email } = (0, $isp1U.useProfileController)();
    return /*#__PURE__*/ $cozmU.createElement($9d2832a2132f7625$export$4a210f0e33a62fe0, {
        name: name,
        aaid: aaid,
        email: email,
        ...props
    });
};
const $9d2832a2132f7625$export$4a210f0e33a62fe0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartCreateFeedbackInternal(t0) {
    const $ = (0, $bDgLe.c)(69);
    const { variant: t1, onClose: onClose, onSubmit: onSubmit, tenantId: tenantId, additionalFields: t2, name: name, aaid: aaid, email: email, customContent: customContent, showDefaultTextFields: t3, summaryDefaultValue: summaryDefaultValue, descriptionDefaultValue: descriptionDefaultValue, categories: categoriesProp } = t0;
    const variant = t1 === undefined ? (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO : t1;
    const additionalFields = t2 === undefined ? {} : t2;
    const showDefaultTextFields = t3 === undefined ? true : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { feedbackTitle: feedbackTitle, rateExperience: rateExperience, entrypointId: entrypointId } = $9d2832a2132f7625$var$getFeedbackConfig(variant);
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $bSAnS.messages).categoryPerformance);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t4) {
        t5 = {
            id: "performance",
            text: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== formatMessage) {
        t6 = formatMessage((0, $bSAnS.messages).categoryResponseQuality);
        $[4] = formatMessage;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t6) {
        t7 = {
            id: "response-quality",
            text: t6
        };
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== formatMessage) {
        t8 = formatMessage((0, $bSAnS.messages).categoryUserExperience);
        $[8] = formatMessage;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t8) {
        t9 = {
            id: "user-experience",
            text: t8
        };
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== formatMessage) {
        t10 = formatMessage((0, $bSAnS.messages).categoryOther);
        $[12] = formatMessage;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== t10) {
        t11 = {
            id: "other",
            text: t10
        };
        $[14] = t10;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t11 || $[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
        t12 = [
            t5,
            t7,
            t9,
            t11
        ];
        $[16] = t11;
        $[17] = t5;
        $[18] = t7;
        $[19] = t9;
        $[20] = t12;
    } else t12 = $[20];
    const defaultCategories = t12;
    const categories = categoriesProp ?? defaultCategories;
    const [experienceRating, setExperienceRating] = (0, $cozmU.useState)(undefined);
    const [selectedCategory, setSelectedCategory] = (0, $cozmU.useState)(undefined);
    let t13;
    let t14;
    if ($[21] !== createAnalyticsEvent || $[22] !== variant) {
        t13 = ()=>{
            createAnalyticsEvent({
                eventType: "screen",
                name: "smartCreateFeedbackCollector",
                attributes: {
                    feedbackVariant: variant
                },
                tags: [
                    "atlaskit"
                ]
            }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
        };
        t14 = [
            variant,
            createAnalyticsEvent
        ];
        $[21] = createAnalyticsEvent;
        $[22] = variant;
        $[23] = t13;
        $[24] = t14;
    } else {
        t13 = $[23];
        t14 = $[24];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    if ($[25] !== createAnalyticsEvent || $[26] !== onClose || $[27] !== variant) {
        t15 = ()=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "closed",
                actionSubject: "smartCreateFeedbackCollector",
                attributes: {
                    feedbackVariant: variant
                },
                tags: [
                    "atlaskit"
                ]
            }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
            onClose();
        };
        $[25] = createAnalyticsEvent;
        $[26] = onClose;
        $[27] = variant;
        $[28] = t15;
    } else t15 = $[28];
    const onCloseWithAnalytics = t15;
    let t16;
    if ($[29] !== createAnalyticsEvent || $[30] !== experienceRating || $[31] !== onSubmit || $[32] !== selectedCategory || $[33] !== variant) {
        t16 = ()=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "submitted",
                actionSubject: "smartCreateFeedbackCollector",
                attributes: {
                    feedbackVariant: variant,
                    experienceRating: experienceRating,
                    selectedCategory: selectedCategory
                },
                tags: [
                    "atlaskit"
                ]
            }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
            onSubmit();
        };
        $[29] = createAnalyticsEvent;
        $[30] = experienceRating;
        $[31] = onSubmit;
        $[32] = selectedCategory;
        $[33] = variant;
        $[34] = t16;
    } else t16 = $[34];
    const onSubmitWithAnalytics = t16;
    const customFields = {
        "Feedback Variant": variant,
        "Selected Category": selectedCategory ?? "",
        "Experience Rating": experienceRating ?? "",
        "Experience Rating Number": experienceRating !== undefined ? (0, $2dlSO.ExperienceRatingToNumber)[experienceRating] : "",
        ...additionalFields
    };
    const T0 = (0, $91uAX.default);
    const t17 = formatMessage(feedbackTitle);
    const t18 = false;
    let t19;
    if ($[35] !== formatMessage) {
        t19 = formatMessage((0, $bSAnS.messages).summaryPlaceholderText);
        $[35] = formatMessage;
        $[36] = t19;
    } else t19 = $[36];
    let t20;
    if ($[37] !== formatMessage) {
        t20 = formatMessage((0, $bSAnS.messages).summaryTitle);
        $[37] = formatMessage;
        $[38] = t20;
    } else t20 = $[38];
    const t21 = formatMessage(rateExperience);
    let t22;
    if ($[39] !== experienceRating || $[40] !== t21) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $2dlSO.EmojiRatingSelector), {
            rating: experienceRating,
            setRating: setExperienceRating,
            label: t21
        });
        $[39] = experienceRating;
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    let t23;
    if ($[42] !== formatMessage) {
        t23 = formatMessage((0, $bSAnS.messages).categoryTitle);
        $[42] = formatMessage;
        $[43] = t23;
    } else t23 = $[43];
    let t24;
    if ($[44] !== categories || $[45] !== selectedCategory || $[46] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $eoEVy.CategoryPillGroup), {
            categories: categories,
            selectedCategory: selectedCategory,
            setSelectedCategory: setSelectedCategory,
            label: t23
        });
        $[44] = categories;
        $[45] = selectedCategory;
        $[46] = t23;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== customContent || $[49] !== t22 || $[50] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, t22, t24, customContent);
        $[48] = customContent;
        $[49] = t22;
        $[50] = t24;
        $[51] = t25;
    } else t25 = $[51];
    const t26 = experienceRating === undefined;
    const t27 = $9d2832a2132f7625$var$constructFeedbackContext(customFields, aaid, tenantId);
    let t28;
    if ($[52] !== T0 || $[53] !== aaid || $[54] !== descriptionDefaultValue || $[55] !== email || $[56] !== entrypointId || $[57] !== name || $[58] !== onCloseWithAnalytics || $[59] !== onSubmitWithAnalytics || $[60] !== showDefaultTextFields || $[61] !== summaryDefaultValue || $[62] !== t17 || $[63] !== t19 || $[64] !== t20 || $[65] !== t25 || $[66] !== t26 || $[67] !== t27) {
        t28 = /*#__PURE__*/ $cozmU.createElement(T0, {
            onClose: onCloseWithAnalytics,
            onSubmit: onSubmitWithAnalytics,
            atlassianAccountId: aaid,
            name: name,
            email: email,
            entrypointId: entrypointId,
            feedbackTitle: t17,
            showTypeField: t18,
            showDefaultTextFields: showDefaultTextFields,
            summaryPlaceholder: t19,
            customTextAreaLabel: t20,
            customContent: t25,
            descriptionDefaultValue: descriptionDefaultValue,
            summaryDefaultValue: summaryDefaultValue,
            disableSubmitButton: t26,
            additionalFields: t27
        });
        $[52] = T0;
        $[53] = aaid;
        $[54] = descriptionDefaultValue;
        $[55] = email;
        $[56] = entrypointId;
        $[57] = name;
        $[58] = onCloseWithAnalytics;
        $[59] = onSubmitWithAnalytics;
        $[60] = showDefaultTextFields;
        $[61] = summaryDefaultValue;
        $[62] = t17;
        $[63] = t19;
        $[64] = t20;
        $[65] = t25;
        $[66] = t26;
        $[67] = t27;
        $[68] = t28;
    } else t28 = $[68];
    return t28;
} : function SmartCreateFeedbackInternal({ variant: variant = (0, $kEjXh.SmartCreateFeedbackVariant).CREATE_WITH_ROVO, onClose: onClose, onSubmit: onSubmit, tenantId: tenantId, additionalFields: additionalFields = {}, name: name, aaid: aaid, email: email, customContent: customContent, showDefaultTextFields: showDefaultTextFields = true, summaryDefaultValue: summaryDefaultValue, descriptionDefaultValue: descriptionDefaultValue, categories: categoriesProp }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { feedbackTitle: feedbackTitle, rateExperience: rateExperience, entrypointId: entrypointId } = $9d2832a2132f7625$var$getFeedbackConfig(variant);
    const defaultCategories = (0, $cozmU.useMemo)(()=>[
            {
                id: 'performance',
                text: formatMessage((0, $bSAnS.messages).categoryPerformance)
            },
            {
                id: 'response-quality',
                text: formatMessage((0, $bSAnS.messages).categoryResponseQuality)
            },
            {
                id: 'user-experience',
                text: formatMessage((0, $bSAnS.messages).categoryUserExperience)
            },
            {
                id: 'other',
                text: formatMessage((0, $bSAnS.messages).categoryOther)
            }
        ], [
        formatMessage
    ]); // Use caller-supplied categories when provided; fall back to the shared defaults.
    const categories = categoriesProp ?? defaultCategories;
    const [experienceRating, setExperienceRating] = (0, $cozmU.useState)(undefined);
    const [selectedCategory, setSelectedCategory] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
    }, [
        variant,
        createAnalyticsEvent
    ]);
    const onCloseWithAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'closed',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
        onClose();
    }, [
        onClose,
        variant,
        createAnalyticsEvent
    ]);
    const onSubmitWithAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant,
                experienceRating: experienceRating,
                selectedCategory: selectedCategory
            },
            tags: [
                'atlaskit'
            ]
        }).fire($9d2832a2132f7625$var$ANALYTICS_CHANNEL);
        onSubmit();
    }, [
        onSubmit,
        variant,
        experienceRating,
        selectedCategory,
        createAnalyticsEvent
    ]);
    const customFields = {
        'Feedback Variant': variant,
        'Selected Category': selectedCategory ?? '',
        'Experience Rating': experienceRating ?? '',
        'Experience Rating Number': experienceRating !== undefined ? (0, $2dlSO.ExperienceRatingToNumber)[experienceRating] : '',
        ...additionalFields
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $91uAX.default), {
        onClose: onCloseWithAnalytics,
        onSubmit: onSubmitWithAnalytics,
        atlassianAccountId: aaid,
        name: name,
        email: email,
        entrypointId: entrypointId,
        feedbackTitle: formatMessage(feedbackTitle),
        showTypeField: false,
        showDefaultTextFields: showDefaultTextFields,
        summaryPlaceholder: formatMessage((0, $bSAnS.messages).summaryPlaceholderText),
        customTextAreaLabel: formatMessage((0, $bSAnS.messages).summaryTitle),
        customContent: /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $2dlSO.EmojiRatingSelector), {
            rating: experienceRating,
            setRating: setExperienceRating,
            label: formatMessage(rateExperience)
        }), /*#__PURE__*/ $cozmU.createElement((0, $eoEVy.CategoryPillGroup), {
            categories: categories,
            selectedCategory: selectedCategory,
            setSelectedCategory: setSelectedCategory,
            label: formatMessage((0, $bSAnS.messages).categoryTitle)
        }), customContent),
        descriptionDefaultValue: descriptionDefaultValue,
        summaryDefaultValue: summaryDefaultValue,
        disableSubmitButton: experienceRating === undefined,
        additionalFields: $9d2832a2132f7625$var$constructFeedbackContext(customFields, aaid, tenantId)
    });
};
module.exports["SmartCreateFeedback"] = $9d2832a2132f7625$export$35c06614b8d216da;

});

parcelRegister("eoEVy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $dUI0h = parcelRequire("dUI0h");


var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

// This file is based on confluence/next/packages/object-sidebar-components/src/sidebar-buttons/FeedbackCollectorButton.tsx
const $5d74c12af684e944$var$styles = {
    categoryPillGroupContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _3TGfC9HnLE _1DCdHi5zaO",
    categoryPill: "_2sNsIgmnOE _0bjKvDS5Zs _3vBAKHjOvk _2V7sgONvrM _3hxITi6wH8 _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _20VacPYbGa _1ANEUSLRg7 _24h04i2Njc _1UtDYzy7kJ _0KLXruDMqu _0Of8r2gVvo _1wydGWgVvo _1Znuxb8HPE _2Zuz6Q8HPE _1eOmH6KcZT",
    categoryPillSelected: "_3vBAKHrzt2 _1UtDYzjTy9 _0KLXruY9q9 _1eOmH6sumd"
};
const $5d74c12af684e944$export$7dad6a6503835f40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { categories: categories, selectedCategory: selectedCategory, setSelectedCategory: setSelectedCategory, label: label } = t0;
    let t1;
    if ($[0] !== setSelectedCategory) {
        t1 = (category)=>(e)=>{
                e.preventDefault();
                setSelectedCategory(category);
            };
        $[0] = setSelectedCategory;
        $[1] = t1;
    } else t1 = $[1];
    const onCategoryButtonClick = t1;
    let t2;
    if ($[2] !== categories || $[3] !== onCategoryButtonClick || $[4] !== selectedCategory) {
        t2 = (t3)=>{
            const { fieldProps: fieldProps } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                "data-name": fieldProps.id,
                xcss: $5d74c12af684e944$var$styles.categoryPillGroupContainer,
                role: "radiogroup"
            }, categories.map((category_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                    role: "radio",
                    "aria-checked": category_0.id === selectedCategory,
                    key: category_0.id,
                    "data-name": category_0.text,
                    "data-value": category_0.id,
                    onClick: onCategoryButtonClick(category_0.id),
                    xcss: (0, $w6R6I.cx)($5d74c12af684e944$var$styles.categoryPill, category_0.id === selectedCategory && $5d74c12af684e944$var$styles.categoryPillSelected)
                }, category_0.text))));
        };
        $[2] = categories;
        $[3] = onCategoryButtonClick;
        $[4] = selectedCategory;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== label || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: label,
            isRequired: false,
            name: "category-group",
            id: "category-group"
        }, t2);
        $[6] = label;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ categories: categories, selectedCategory: selectedCategory, setSelectedCategory: setSelectedCategory, label: label })=>{
    const onCategoryButtonClick = (0, $cozmU.useCallback)((category)=>(e)=>{
            e.preventDefault();
            setSelectedCategory(category);
        }, [
        setSelectedCategory
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: label,
        isRequired: false,
        name: "category-group",
        id: "category-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            "data-name": fieldProps.id,
            xcss: $5d74c12af684e944$var$styles.categoryPillGroupContainer,
            role: "radiogroup"
        }, categories.map((category_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                role: "radio",
                "aria-checked": category_0.id === selectedCategory,
                key: category_0.id,
                "data-name": category_0.text,
                "data-value": category_0.id,
                onClick: onCategoryButtonClick(category_0.id),
                xcss: (0, $w6R6I.cx)($5d74c12af684e944$var$styles.categoryPill, category_0.id === selectedCategory && $5d74c12af684e944$var$styles.categoryPillSelected)
            }, category_0.text)))));
};
module.exports["CategoryPillGroup"] = $5d74c12af684e944$export$7dad6a6503835f40;

});

parcelRegister("2dlSO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $dQLwo = parcelRequire("dQLwo");


var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $4C3ql = parcelRequire("4C3ql");

const $c0d088953076e6a9$var$styles = {
    emojiSelectionContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _1DCdHi5zaO",
    emojiButton: "_2sNsIgXwEm _0bjKvDKxmn _3vBAKHjOvk _2V7sgONvrM _3hxITi6wH8 _0KLXrujOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _1eOmH6KcZT",
    emojiButtonSelected: "_3vBAKHnXvL _0KLXruY9q9 _1eOmH6sumd"
};
var $c0d088953076e6a9$export$d51aadc3a803b62 = /*#__PURE__*/ function(ExperienceRating) {
    ExperienceRating["VeryDissatisfied"] = "Very dissatisfied";
    ExperienceRating["Dissatisfied"] = "Dissatisfied";
    ExperienceRating["Neutral"] = "Neutral";
    ExperienceRating["Satisfied"] = "Satisfied";
    ExperienceRating["VerySatisfied"] = "Very satisfied";
    return ExperienceRating;
}({});
const $c0d088953076e6a9$export$1224208ff0eb2a38 = {
    ["Very dissatisfied"]: 1,
    ["Dissatisfied"]: 2,
    ["Neutral"]: 3,
    ["Satisfied"]: 4,
    ["Very satisfied"]: 5
};
const $c0d088953076e6a9$var$OPTION_DATA = [
    {
        emoji: "\uD83D\uDE20",
        experienceRating: "Very dissatisfied"
    },
    {
        emoji: "\u2639\uFE0F",
        experienceRating: "Dissatisfied"
    },
    {
        emoji: "\uD83D\uDE10",
        experienceRating: "Neutral"
    },
    {
        emoji: "\uD83D\uDE42",
        experienceRating: "Satisfied"
    },
    {
        emoji: "\uD83D\uDE03",
        experienceRating: "Very satisfied"
    }
];
const $c0d088953076e6a9$export$dfef634eb7f87ea8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { rating: rating, setRating: setRating, label: label } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== setRating) {
        t1 = (option, fieldProps)=>(e)=>{
                e.preventDefault();
                setRating(option.experienceRating);
                fieldProps.onChange(option.experienceRating);
            };
        $[0] = setRating;
        $[1] = t1;
    } else t1 = $[1];
    const onEmojiButtonClick = t1;
    let t2;
    if ($[2] !== formatMessage) {
        t2 = (value)=>{
            if (!value) return formatMessage((0, $4C3ql.messages).validationErrorRatingRequired);
        };
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    const validateRating = t2;
    let t3;
    if ($[4] !== onEmojiButtonClick || $[5] !== rating) {
        t3 = (t4)=>{
            const { fieldProps: fieldProps_0, error: error } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                "data-name": fieldProps_0.id,
                xcss: $c0d088953076e6a9$var$styles.emojiSelectionContainer,
                role: "radiogroup"
            }, $c0d088953076e6a9$var$OPTION_DATA.map((option_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                    role: "radio",
                    "aria-checked": rating === option_0.experienceRating,
                    key: option_0.experienceRating,
                    "data-name": option_0.experienceRating,
                    "data-value": option_0.experienceRating,
                    testId: `emoji-rating-${$c0d088953076e6a9$export$1224208ff0eb2a38[option_0.experienceRating]}`,
                    onClick: onEmojiButtonClick(option_0, fieldProps_0),
                    xcss: (0, $w6R6I.cx)($c0d088953076e6a9$var$styles.emojiButton, rating === option_0.experienceRating && $c0d088953076e6a9$var$styles.emojiButtonSelected)
                }, option_0.emoji))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)));
        };
        $[4] = onEmojiButtonClick;
        $[5] = rating;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== label || $[8] !== t3 || $[9] !== validateRating) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: label,
            isRequired: true,
            name: "rate-experience",
            id: "rate-experience",
            validate: validateRating
        }, t3);
        $[7] = label;
        $[8] = t3;
        $[9] = validateRating;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ rating: rating, setRating: setRating, label: label })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onEmojiButtonClick = (0, $cozmU.useCallback)((option, fieldProps)=>(e)=>{
            e.preventDefault();
            setRating(option.experienceRating);
            fieldProps.onChange(option.experienceRating);
        }, [
        setRating
    ]);
    const validateRating = (value)=>{
        if (!value) return formatMessage((0, $4C3ql.messages).validationErrorRatingRequired);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: label,
        isRequired: true,
        name: "rate-experience",
        id: "rate-experience",
        validate: validateRating
    }, ({ fieldProps: fieldProps_0, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            "data-name": fieldProps_0.id,
            xcss: $c0d088953076e6a9$var$styles.emojiSelectionContainer,
            role: "radiogroup"
        }, $c0d088953076e6a9$var$OPTION_DATA.map((option_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                role: "radio",
                "aria-checked": rating === option_0.experienceRating,
                key: option_0.experienceRating,
                "data-name": option_0.experienceRating,
                "data-value": option_0.experienceRating,
                testId: `emoji-rating-${$c0d088953076e6a9$export$1224208ff0eb2a38[option_0.experienceRating]}`,
                onClick: onEmojiButtonClick(option_0, fieldProps_0),
                xcss: (0, $w6R6I.cx)($c0d088953076e6a9$var$styles.emojiButton, rating === option_0.experienceRating && $c0d088953076e6a9$var$styles.emojiButtonSelected)
            }, option_0.emoji))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error))));
};
module.exports["ExperienceRatingToNumber"] = $c0d088953076e6a9$export$1224208ff0eb2a38;
module.exports["EmojiRatingSelector"] = $c0d088953076e6a9$export$dfef634eb7f87ea8;

});

parcelRegister("4C3ql", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2536a32f2337ad3c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    validationErrorRatingRequired: {
        id: "smart-create-feedback.emoji-rating-selector.validation.rating.required",
        defaultMessage: "Please select a rating before submitting"
    }
});
module.exports["messages"] = $2536a32f2337ad3c$export$defe85febe8b728c;

});

parcelRegister("bSAnS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dc168e6918416fa8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "smart-create-feedback.feedback-title",
        defaultMessage: "Help us improve Create with Rovo"
    },
    rateExperience: {
        id: "smart-create-feedback.emoji-rating-selector.label",
        defaultMessage: "Please rate your experience with Create with Rovo:"
    },
    feedbackTitleNoCreate: {
        id: "smart-create-feedback.feedback-title-no-create",
        defaultMessage: "Help us improve Rovo"
    },
    rateExperienceNoCreate: {
        id: "smart-create-feedback.emoji-rating-selector.label-no-create",
        defaultMessage: "Please rate your experience with Rovo:"
    },
    feedbackTitleRemix: {
        id: "smart-create-feedback.feedback-title-remix",
        defaultMessage: "Help us improve Remix"
    },
    rateExperienceRemix: {
        id: "smart-create-feedback.emoji-rating-selector.label-remix",
        defaultMessage: "Please rate your experience with Remix:"
    },
    feedbackTitleSlides: {
        id: "smart-create-feedback.feedback-title-slides",
        defaultMessage: "Help us improve Slides"
    },
    rateExperienceSlides: {
        id: "smart-create-feedback.emoji-rating-selector.label-slides",
        defaultMessage: "Please rate your experience with Slides:"
    },
    feedbackTitleRovoInsights: {
        id: "smart-create-feedback.feedback-title-rovo-insights",
        defaultMessage: "Help us improve Rovo Insights"
    },
    rateExperienceRovoInsights: {
        id: "smart-create-feedback.emoji-rating-selector.label-rovo-insights",
        defaultMessage: "Please rate your experience with Rovo Insights:"
    },
    summaryTitle: {
        id: "smart-create-feedback.summary-title",
        defaultMessage: "Tell us more about your experience:"
    },
    categoryTitle: {
        id: "smart-create-feedback.category-title",
        defaultMessage: "What category best describes your feedback? (optional)"
    },
    categoryPerformance: {
        id: "smart-create-feedback.category.performance",
        defaultMessage: "Performance"
    },
    categoryResponseQuality: {
        id: "smart-create-feedback.category.response-quality",
        defaultMessage: "Response quality"
    },
    categoryUserExperience: {
        id: "smart-create-feedback.category.user-experience",
        defaultMessage: "User experience"
    },
    categoryOther: {
        id: "smart-create-feedback.category.other",
        defaultMessage: "Other"
    },
    categoryUnderstandingMyRequest: {
        id: "smart-create-feedback.category.understanding-my-request",
        defaultMessage: "Understanding my request"
    },
    categoryNumberOfQuestions: {
        id: "smart-create-feedback.category.number-of-questions",
        defaultMessage: "Number of questions"
    },
    categoryPlanQuality: {
        id: "smart-create-feedback.category.plan-quality",
        defaultMessage: "Plan quality"
    },
    categorySpeed: {
        id: "smart-create-feedback.category.speed",
        defaultMessage: "Speed"
    },
    categoryEaseInEditing: {
        id: "smart-create-feedback.category.ease-in-editing",
        defaultMessage: "Ease in editing"
    },
    categoryInterfaceUsability: {
        id: "smart-create-feedback.category.interface-usability",
        defaultMessage: "Interface usability"
    },
    categoryStepCompletion: {
        id: "smart-create-feedback.category.step-completion",
        defaultMessage: "Step completion"
    },
    summaryPlaceholderText: {
        id: "smart-create-feedback.summary-placeholder-text",
        defaultMessage: "What are we doing well? What could be improved?"
    }
});
module.exports["messages"] = $dc168e6918416fa8$export$defe85febe8b728c;

});

parcelRegister("kEjXh", function(module, exports) {
var $9c0da96e768fd607$export$cc1cd6888a5f186c = /*#__PURE__*/ function(SmartCreateFeedbackVariant) {
    SmartCreateFeedbackVariant["ROVO"] = "rovo";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO"] = "create-with-rovo";
    // Confluence
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO_FROM_JIRA"] = "create-with-rovo-from-jira";
    // Jira
    SmartCreateFeedbackVariant["REMIX"] = "remix";
    SmartCreateFeedbackVariant["SLIDES"] = "slides";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO_FROM_JSM"] = "create-with-rovo-from-jsm";
    SmartCreateFeedbackVariant["ROVO_INSIGHTS_FROM_JSM"] = "rovo-insights-from-jsm";
    return SmartCreateFeedbackVariant;
}({});
module.exports["SmartCreateFeedbackVariant"] = $9c0da96e768fd607$export$cc1cd6888a5f186c;

});


//# sourceMappingURL=showFeedbackFlag.0c27b068.js.map
